import { ICenter } from '@nkr/models/index';
import { subSections } from './subsections';
import { DonorShieldStatus, OrganType } from '@nkr/enums/index';
import { RouteComponentProps } from 'react-router';
import { useAppHookContext } from '@nkr/utils/rest-api';
import DonorSearch from './donor-search';
import DonorIntake from './donor-intake';
import SwapDonors from './swap-donors/components';
import Reconciliation from './reconciliation';
import DonorsNav from './tabs';
import WageAndTravelList from './watr/components/wage-and-travel-list';
import DonorShieldDirectList from './donor-shield-direct/list';
import DonorShieldDirectAddEdit from './donor-shield-direct/add-edit/index';
import VoucherHolderAddEdit from '../voucher-holder/add-edit';
import VoucherProgram from './voucher-program';

interface IProps extends RouteComponentProps<{ voucherHolderId: string }> {
    center: ICenter,
    isAdmin: boolean,
    isCenter: boolean,
    isAdminLogin: boolean,
    subSection: string,
    tertiarySection: string,
    donorId?: number,
    regId?: number,
    voucherHolderId?: number
}

const Donors = (props: IProps) => {
    if (props.center == null)
        return null;

    const { app } = useAppHookContext();

    const isMicrositeParticipant = props.center != null ? props.center.isMicrositeParticipant : false;
    const isFollowUpParticipant = props.center != null ? props.center.isFollowUpParticipant : false;
    const isInDonorShieldKidney = props.center != null ? app.site.organType == OrganType.Kidney && props.center.isInDonorShield == DonorShieldStatus.On : false;
    const isInDonorShieldLiver = props.center != null ? app.site.organType == OrganType.Liver && props.center.isDonorShieldDirectLiverCenter : false;
    const centerId = props.center != null ? props.center.id : 0;

    const subSection = props.subSection.toUpperCase();
    const tertiarySection = props.tertiarySection != null ? props.tertiarySection.toUpperCase() : '';

    return (
        <div style={{ padding: '0px 10px' }}>
            <DonorsNav
                activeKey={subSection}
                centerId={centerId}
                isMicrositeParticipant={isMicrositeParticipant}
                isAdmin={props.isAdmin}
                isFollowUpParticipant={isFollowUpParticipant}
                isInDonorShield={isInDonorShieldKidney || isInDonorShieldLiver}
                organType={app.site.organType}
                onTabSelect={() => null}
            />

            <div style={{ width: "100%", borderLeft: "1px solid #ddd", borderRight: "1px solid #ddd", borderBottom: "1px solid #ddd", minHeight: "70vh", paddingTop: 20, paddingLeft: 10, paddingRight: 10, backgroundColor: "#FFF" }}>
                {subSection == subSections.SEARCH && (
                    <DonorSearch
                        centerId={centerId}
                    />
                )}

                {subSection == subSections.DONOR_INTAKE && (
                    <DonorIntake
                        subSection={props.tertiarySection}
                        centerId={centerId}
                        regId={props.regId}
                        isSuperUser={false}
                        isCenter={props.isCenter}
                    />
                )}


                {subSection == subSections.SWAP && (
                    <SwapDonors
                        centerId={centerId}
                        activeKey={props.tertiarySection}
                        isAdmin={props.isAdmin} />
                )}

                {subSection == subSections.DONOR_SHIELD_DIRECT && (
                    <>
                        {(tertiarySection == 'PENDING-TRANSPLANT' || tertiarySection == 'TRANSPLANTED') && (
                            <DonorShieldDirectList
                                centerId={centerId}
                                isSuperUser={props.isAdmin}
                                donorRecordId={props.donorId}
                                section={props.tertiarySection}
                            />
                        )}

                        {(tertiarySection == 'EDIT-DONOR' || tertiarySection == 'ADD-DONOR') && (
                            <DonorShieldDirectAddEdit
                                centerId={centerId}
                                isAdmin={props.isAdmin}
                                donorShieldId={props.donorId}
                                isAdminLogin={props.isAdminLogin}
                            />
                        )}
                    </>
                )}

                {subSection == subSections.WAGE_AND_TRAVEL && (
                    <WageAndTravelList
                        centerId={centerId}
                        isSuperUser={props.isAdmin}
                        section={props.tertiarySection}
                    />
                )}

                {subSection == subSections.RECONCILIATION && (
                    <Reconciliation
                        centerId={centerId}
                    />
                )}

                {subSection == 'VOUCHER-HOLDER-EDIT' && (
                    <div>
                        <VoucherHolderAddEdit
                            voucherHolderId={props.voucherHolderId}
                            centerId={props.center.id}
                            donorId={0}
                            isAdmin={props.isAdmin}
                            isAdminLogin={props.isAdminLogin}
                        />
                    </div>
                )}

                {subSection == subSections.VOUCHER_HOLDER_EDIT && (
                    <div>
                        <VoucherHolderAddEdit
                            voucherHolderId={props.voucherHolderId}
                            centerId={props.center.id}
                            donorId={0}
                            isAdmin={props.isAdmin}
                            isAdminLogin={props.isAdminLogin}
                        />
                    </div>
                )}

                {subSection == subSections.VOUCHER_PROGRAM && (
                    <div>
                        <VoucherProgram centerId={props.center.id} />
                    </div>
                )}
            </div>
        </div>
    );
}

export default Donors;